export default __webpack_public_path__ + "static/media/DinosaursSeaReptiles_04.bb972155.png";